import { RootState } from '../../../Store/index';

export const selectUserList = (state: RootState) => state.UsersReducer.userList;
export const selectCurrentUser = (state: RootState) => state.UsersReducer.currentUser;
export const selectIsUserModalOpen = (state: RootState) => state.UsersReducer.isUserModalOpen;